/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FileAccessResponseBody,
  PagedAndSyncedResultCreditNoteSummary,
  SortDirection,
} from '../models/index';
import {
    FileAccessResponseBodyFromJSON,
    FileAccessResponseBodyToJSON,
    PagedAndSyncedResultCreditNoteSummaryFromJSON,
    PagedAndSyncedResultCreditNoteSummaryToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface DownloadCreditNoteDocumentRequest {
    downloadToken: string;
}

export interface GetCreditNoteSummariesOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
    fullTextQuery?: string;
    sortByCreatedAt?: SortDirection;
    sortByCreditNoteNumber?: SortDirection;
    sortByAmount?: SortDirection;
    sortByRefundMethod?: SortDirection;
    sortByRefundedAt?: SortDirection;
    sortByDescription?: SortDirection;
}

export interface RequestCreditNoteDownloadRequest {
    companyCode: string;
    creditNoteNumber: number;
}

/**
 * 
 */
export class CreditNoteResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for downloadCreditNoteDocument without sending the request
     */
    async downloadCreditNoteDocumentRequestOpts(requestParameters: DownloadCreditNoteDocumentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['downloadToken'] == null) {
            throw new runtime.RequiredError(
                'downloadToken',
                'Required parameter "downloadToken" was null or undefined when calling downloadCreditNoteDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/credit-note/download/{downloadToken}`;
        urlPath = urlPath.replace(`{${"downloadToken"}}`, encodeURIComponent(String(requestParameters['downloadToken'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async downloadCreditNoteDocumentRaw(requestParameters: DownloadCreditNoteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.downloadCreditNoteDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async downloadCreditNoteDocument(requestParameters: DownloadCreditNoteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.downloadCreditNoteDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCreditNoteSummariesOfCurrentRetailer without sending the request
     */
    async getCreditNoteSummariesOfCurrentRetailerRequestOpts(requestParameters: GetCreditNoteSummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['fullTextQuery'] != null) {
            queryParameters['fullTextQuery'] = requestParameters['fullTextQuery'];
        }

        if (requestParameters['sortByCreatedAt'] != null) {
            queryParameters['sortByCreatedAt'] = requestParameters['sortByCreatedAt'];
        }

        if (requestParameters['sortByCreditNoteNumber'] != null) {
            queryParameters['sortByCreditNoteNumber'] = requestParameters['sortByCreditNoteNumber'];
        }

        if (requestParameters['sortByAmount'] != null) {
            queryParameters['sortByAmount'] = requestParameters['sortByAmount'];
        }

        if (requestParameters['sortByRefundMethod'] != null) {
            queryParameters['sortByRefundMethod'] = requestParameters['sortByRefundMethod'];
        }

        if (requestParameters['sortByRefundedAt'] != null) {
            queryParameters['sortByRefundedAt'] = requestParameters['sortByRefundedAt'];
        }

        if (requestParameters['sortByDescription'] != null) {
            queryParameters['sortByDescription'] = requestParameters['sortByDescription'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/credit-note`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCreditNoteSummariesOfCurrentRetailerRaw(requestParameters: GetCreditNoteSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedAndSyncedResultCreditNoteSummary>> {
        const requestOptions = await this.getCreditNoteSummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedAndSyncedResultCreditNoteSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getCreditNoteSummariesOfCurrentRetailer(requestParameters: GetCreditNoteSummariesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedAndSyncedResultCreditNoteSummary> {
        const response = await this.getCreditNoteSummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for requestCreditNoteDownload without sending the request
     */
    async requestCreditNoteDownloadRequestOpts(requestParameters: RequestCreditNoteDownloadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['companyCode'] == null) {
            throw new runtime.RequiredError(
                'companyCode',
                'Required parameter "companyCode" was null or undefined when calling requestCreditNoteDownload().'
            );
        }

        if (requestParameters['creditNoteNumber'] == null) {
            throw new runtime.RequiredError(
                'creditNoteNumber',
                'Required parameter "creditNoteNumber" was null or undefined when calling requestCreditNoteDownload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyCode'] != null) {
            queryParameters['companyCode'] = requestParameters['companyCode'];
        }

        if (requestParameters['creditNoteNumber'] != null) {
            queryParameters['creditNoteNumber'] = requestParameters['creditNoteNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/credit-note/download`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async requestCreditNoteDownloadRaw(requestParameters: RequestCreditNoteDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileAccessResponseBody>> {
        const requestOptions = await this.requestCreditNoteDownloadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileAccessResponseBodyFromJSON(jsonValue));
    }

    /**
     */
    async requestCreditNoteDownload(requestParameters: RequestCreditNoteDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileAccessResponseBody> {
        const response = await this.requestCreditNoteDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
